import React from 'react';
import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';

const StyledModal = styled(AntdModal)`
  &.ant-modal {
    font-size: 25px;
    background: #002636;
    border: 1px solid #fff;
    padding: 10px 30px;

    .ant-modal-content, .ant-modal-header {
      background-color: unset;
    }

    .ant-modal-header, .ant-modal-footer {
      border: unset;
    }

    .ant-modal-title {
      color: #fff;
      font-weight: 700;
      font-size: 1.5em;
      text-align: center;
      margin: 10px 0;
    }

    .contactInformation {
      text-align: center;
    }

    .ant-modal-body, .ant-modal-content {
      color: #fff;
      white-space: pre-line;
      font-size: 1em;
    }

    .ant-modal-footer {
      display: flex;
      justify-content: center;
      padding: 20px 0;

      .ant-btn + .ant-btn {
        margin: 0 0 0 30px;
      }
    }
  }
`;

const Modal = ({ children, title, isModalVisible, handleOk, handleCancel, ...rest }) =>
  <StyledModal title={title} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} {...rest}>
    {children}
  </StyledModal>;

export default Modal;
